// helpers.ts — Pure utility functions for P9209 (Leave of Absence Request) form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Derive the approval status for display */
export const getApprovalStatus = (record: { f90n_80?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  switch (record.f90n_80) {
    case 'P': return { text: '已核准', cls: 'badge-success' };
    default: return { text: '待審', cls: 'badge-warning' };
  }
};

/** Check if any approval has been given (locks modify/delete) */
export const isApprovalLocked = (record: { f90n_61?: string; f90n_71?: string; f90n_76?: string } | null): boolean => {
  if (!record) return false;
  return !!(
    (record.f90n_61 && record.f90n_61.trim()) ||
    (record.f90n_71 && record.f90n_71.trim()) ||
    (record.f90n_76 && record.f90n_76.trim())
  );
};

/** Display value for optiongroup Y/N/blank */
export const approvalLabel = (val: string | undefined): string => {
  if (!val || !val.trim()) return '-';
  return val.trim() === 'Y' ? 'Y (核准)' : 'N (不准)';
};

/** Fields that are always readonly (never editable) */
const ALWAYS_READONLY = new Set([
  'f90n_01', // 單號
  'f90n_11', // 員工代號
  'f90n_12', // 申請日期
  'f90n_21', // 部門
  'f90n_22', // 職稱
  'f90n_23', // 到職日
  'f90n_57', // 人事主管
  'f90n_58', // 確認日期
  // Page2 全部唯讀
  'f90n_56', 'f90n_61', 'f90n_62', 'f90n_63', 'f90n_64',
  'f90n_66', 'f90n_67', 'f90n_68', 'f90n_69',
  'f90n_71', 'f90n_72', 'f90n_73', 'f90n_74',
  'f90n_76', 'f90n_77', 'f90n_78', 'f90n_79',
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, _mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  return false;
};
